module.exports = __webpack_public_path__ + "videos/video-oneclick-benefit-profit.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/oneclick/video-oneclick-benefit-profit.mp4
// module id = 915
// module chunks = 1